import { Component } from '@angular/core';
import { AccountMaintenanceMessagesService } from '../shared/services/account-maintenance-messages.service';

@Component({
  selector: 'app-account-maintenance',
  styleUrls: [ './account-maintenance.component.scss' ],
  templateUrl: './account-maintenance.component.html',
  standalone: false
})
export class AccountMaintenanceComponent {
  public constructor(
    public messagesService: AccountMaintenanceMessagesService
  ) {}
}

